import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import {
  BtnGroupStyle,
  ContentStyle,
  DatePickerField,
  DRxSelectStyle,
  greyColor,
  InputSMBoxStyle,
  warnColor,
  IframeStyle,
} from "../../../Theme";
import { YSButton } from "../../../uikit/YSButton";
import { ErrorMessage, Form, Formik } from "formik";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import moment from "moment";
import DRxSelect from "../../../uikit/DRxSelect";
import { GeneratePatientMedicationReport } from "../../../Apis/AuthApiServices";
import { useState } from "react";
import YSSnackBar from "../../../uikit/YSSnackBar";
import { YSSelectSearch } from "../../../uikit/YSSelectSearch";
import { loadingDrugSearchAjax } from "../../../Redux/Slice/DrugSearchAjaxSlice";
import { useDispatch, useSelector } from "react-redux";
import * as yup from "yup";
import { REPORT_BASE_URL } from "../../../Apis/Constants";

const reportType = [
  { value: "1", label: "Patient By Medication" },
  { value: "2", label: "Medication By Patient" },
];

const initialStatePatientMedicationReport = {
  fromDate: "",
  toDate: "",
  reportType: "1",
  drugName: "",
  drugId: "",
};

export default function PatientMedicationReport() {
  const [data, setData] = useState(initialStatePatientMedicationReport);
  const [printActive, setPrintActive] = useState(false);
  const [reportUrl, setReportUrl] = useState("");
  const dispatch = useDispatch();
  const DrugSearchAjaxState = useSelector((state: any) => {
    return { ...state.DrugSearchAjaxSlice };
  }); //redux data
  const [stateData, setStateData] = useState<any>({
    message: "",
    open: false,
    variant: "",
  });

  const getGeneratePatientMedicationReport = async (values: any) => {
    try {
      const doctorId: any = localStorage.getItem("doctorId");
      const params = new URLSearchParams();
      params.append("doctorId", doctorId);
      params.append("fromDate", values?.fromDate);
      params.append("toDate", values?.toDate);
      params.append("drugName", values?.drugName);
      params.append("reportType", values?.reportType);
      params.append("drugId", values?.drugId);

      const result = await GeneratePatientMedicationReport(params);
      if (result?.data?.digitalRxStatusCode === 200) {
        setReportUrl(result?.data?.response[0]?.reportUrl);
        setPrintActive(true);
      } else {
        setStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.digitalRxStatusMessage,
            variant: "error",
            open: true,
          };
        });
      }
    } catch (err) {
      setStateData((prevState: any) => {
        return {
          ...prevState,
          message: "Something went wrong!",
          variant: "error",
          open: true,
        };
      });
    }
  };

  return (
    <>
      <ContentStyle>
        {printActive ? (
          <Grid
            container
            item
            xs={12}
            spacing={0}
            alignItems="top"
            justifyContent="space-between"
            columnSpacing={3}
          >
            <Grid item xs={12}>
              <IframeStyle>
                <iframe src={REPORT_BASE_URL + reportUrl} title="PrintReport" />
              </IframeStyle>
            </Grid>
            <Grid item xs={12}>
              <BtnGroupStyle className="right">
                <YSButton
                  className=""
                  children={"Back"}
                  variant={"outlined"}
                  size={"large"}
                  onClick={() => {
                    setPrintActive(false);
                  }}
                />{" "}
              </BtnGroupStyle>
            </Grid>
          </Grid>
        ) : (
          <>
            <Typography component="h6" color="primary" variant="h6">
              Patient Medication Report
            </Typography>

            <Formik
              initialValues={data}
              validationSchema={yup.object().shape({
                drugName: yup.string().required("Drug Name is Required").min(4),
              })}
              onSubmit={(values) => {
                setData(values);
                getGeneratePatientMedicationReport(values);
              }}
            >
              {(formProps) => (
                <Form onSubmit={formProps.handleSubmit}>
                  <Grid
                    container
                    item
                    xs={12}
                    spacing={0}
                    alignItems="top"
                    justifyContent="center"
                    columnSpacing={3}
                  >
                    <Grid item xs={12} md={8}>
                      <InputSMBoxStyle>
                        <Typography
                          component="label"
                          color={greyColor}
                          variant="body2"
                          htmlFor="vendorname"
                        >
                          Drug Name
                          <Typography
                            component="span"
                            color={warnColor}
                            variant="body1"
                          >
                            *
                          </Typography>
                        </Typography>{" "}
                        <Box>
                          <DRxSelectStyle>
                            <YSSelectSearch
                              id="drugname"
                              isOptionEqualToValue={(option: any, value: any) =>
                                option.label === value
                              }
                              options={
                                DrugSearchAjaxState?.Items?.map(
                                  (item: any, index: any) => ({
                                    value: item.drugId,
                                    label: item.drugName,
                                  })
                                ) ?? [{ value: "", label: "" }]
                              }
                              name="drugName"
                              value={formProps.values.drugName}
                              onInputChange={(option: any, e: any) => {
                                formProps.setFieldValue("drugName", e);
                                let drugName = {
                                  drugName: e,
                                };
                                if (e.length >= 4) {
                                  dispatch(loadingDrugSearchAjax(drugName));
                                }
                              }}
                              onChange={(event: any, value: any) => {
                                formProps.setFieldValue("drugId", value.value);
                              }}
                            />
                          </DRxSelectStyle>
                        </Box>
                      </InputSMBoxStyle>
                    </Grid>

                    <Grid item xs={12} md={8}>
                      <InputSMBoxStyle>
                        <Typography
                          component="label"
                          color={greyColor}
                          variant="body2"
                          htmlFor="fromdate"
                        >
                          From Date
                        </Typography>

                        <Box>
                          <DatePickerField>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                              <DatePicker
                                inputFormat="MM/dd/yyyy"
                                value={formProps.values.fromDate}
                                onChange={(e) => {
                                  formProps.setFieldValue(
                                    "fromDate",
                                    moment(e).format("MM/DD/yyyy")
                                  );
                                }}
                                renderInput={(params) => (
                                  <>
                                    <TextField
                                      {...params}
                                      error={
                                        formProps.touched.fromDate &&
                                        Boolean(formProps.errors.fromDate)
                                      }
                                    />
                                    <Typography
                                      color="error"
                                      className="error"
                                      variant="body2"
                                      component="div"
                                    >
                                      <ErrorMessage name="fromDate" />
                                    </Typography>
                                  </>
                                )}
                              />
                            </LocalizationProvider>
                          </DatePickerField>
                        </Box>
                      </InputSMBoxStyle>
                    </Grid>
                    <Grid item xs={12} md={8}>
                      <InputSMBoxStyle>
                        <Typography
                          component="label"
                          color={greyColor}
                          variant="body2"
                          htmlFor="toDate"
                        >
                          To Date
                        </Typography>

                        <Box>
                          <DatePickerField>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                              <DatePicker
                                inputFormat="MM/dd/yyyy"
                                value={formProps.values.toDate}
                                onChange={(e) => {
                                  formProps.setFieldValue(
                                    "toDate",
                                    moment(e).format("MM/DD/yyyy")
                                  );
                                }}
                                renderInput={(params) => (
                                  <>
                                    <TextField
                                      {...params}
                                      error={
                                        formProps.touched.toDate &&
                                        Boolean(formProps.errors.toDate)
                                      }
                                    />
                                    <Typography
                                      color="error"
                                      className="error"
                                      variant="body2"
                                      component="div"
                                    >
                                      <ErrorMessage name="toDate" />
                                    </Typography>
                                  </>
                                )}
                              />
                            </LocalizationProvider>
                          </DatePickerField>
                        </Box>
                      </InputSMBoxStyle>
                    </Grid>
                    <Grid item xs={12} md={8}>
                      <InputSMBoxStyle>
                        <Typography
                          component="label"
                          color={greyColor}
                          variant="body2"
                          htmlFor="reportType"
                        >
                          Report Type
                        </Typography>
                        <Box>
                          <DRxSelectStyle>
                            <DRxSelect
                              name="reportType"
                              id="reportType"
                              data={reportType}
                            />
                          </DRxSelectStyle>
                        </Box>
                      </InputSMBoxStyle>
                    </Grid>
                    <Grid item xs={12} textAlign={"center"}>
                      {" "}
                      <YSButton
                        style={{ marginTop: 35 }}
                        size="large"
                        className=""
                        color="primary"
                        dataTestId="submitBtn"
                        variant="contained"
                        disabled={false}
                        type="submit"
                        children={"Generate Reports"}
                        onClick={null}
                      />
                    </Grid>
                  </Grid>
                </Form>
              )}
            </Formik>
          </>
        )}
      </ContentStyle>
      <YSSnackBar
        message={stateData.message}
        variant={stateData.variant}
        open={stateData.open}
        handleClose={() => {
          setStateData((prevState: any) => {
            return { ...prevState, open: false };
          });
        }}
      />
    </>
  );
}
